import {
  Button,
  Container,
  Image,
  SimpleGrid,
  Text,
  Title,
} from "@mantine/core";
import image from "../../assets/images/not_found.svg";
import classes from "./NotFound.module.css";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mantine/hooks";
import { useEffect, useState } from "react";

export function NotFound() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 805px)");
  const status = isMobile ? "mobile" : "desktop";
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true); // 👈 Set true setelah komponen mount
  }, []);

  return (
    <Container className={classes.root}>
      <SimpleGrid spacing={{ base: 40, sm: 80 }} cols={{ base: 1, sm: 2 }}>
        {status === "mobile" && isMounted && (
          <Image src={image} />
        )}
        <div>
          <Title className={classes.title}>Something is not right...</Title>
          <Text c="dimmed" size="lg">
            Page you are trying to open does not exist. You may have mistyped
            the address, or the page has been moved to another URL. If you think
            this is an error contact support.
          </Text>
          <Button
            variant="outline"
            size="md"
            mt="xl"
            onClick={() => navigate("/")}
            className={classes.control}
          >
            Get back to home page
          </Button>
        </div>
        {status === "desktop" && isMounted && (
          <Image src={image} />
        )}
      </SimpleGrid>
    </Container>
  );
}
